import {
  DashboardOutlined,
  DollarOutlined,
  CoffeeOutlined,
  CarOutlined,
  MedicineBoxOutlined
} from '@ant-design/icons';

const dashboard = {
  id: 'group-dashboard',
  title: 'Dashboards',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboards',
      type: 'collapse',
      icon: DashboardOutlined,
      children: [
        {
          id: 'finance-dashboard',
          title: 'Dashboard',
          type: 'item',
          url: '/dashboard/finance',
          icon: DollarOutlined
        },
        // {
        //   id: 'kitchen-dashboard',
        //   title: 'Kitchen',
        //   type: 'item',
        //   url: '/dashboard/kitchen',
        //   icon: CoffeeOutlined
        // },
        // {
        //   id: 'rider-dashboard',
        //   title: 'Rider',
        //   type: 'item',
        //   url: '/dashboard/rider',
        //   icon: CarOutlined
        // },
        // {
        //   id: 'consultation-dashboard',
        //   title: 'Consultation',
        //   type: 'item',
        //   url: '/dashboard/consultation',
        //   icon: MedicineBoxOutlined
        // }
      ]
    }
  ]
};

export default dashboard;
